import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useDialogUsage } from '../../../../features/usage-tracking/hooks/useDialogUsage';

interface Props {
  onExecute: () => void;
  /** Marker der Nutzungserfassung (RITA-1504); der Wrapper bildet ihn aus dem Tabellennamen. */
  usageKey?: string;
}

function DeleteButton({ onExecute, usageKey }: Props) {
  // RITA-1504 (Entwurf E): Die Rückfrage des Browsers ist der Bestätigungsdialog dieser Zeile;
  // sie trägt denselben Namen wie der Marker des Knopfes ('<tabelle>.loeschen'). Ohne Marker
  // meldet der Knopf nichts — ein erfundener Name wäre in der Auswertung eine eigene Zeile.
  const dialogUsage = useDialogUsage(usageKey ?? '');

  return (
    <IconButton
      onClick={() => {
        dialogUsage.reset();
        // eslint-disable-next-line
        const bestaetigt = window.confirm('Möchten Sie diese Zeile wirklich löschen?');
        if (usageKey) {
          if (bestaetigt) {
            dialogUsage.confirmed();
          } else {
            dialogUsage.cancelled();
          }
        }
        if (bestaetigt) {
          onExecute();
        }
      }}
      title="Zeile löschen"
      data-usage={usageKey}
    >
      <DeleteIcon />
    </IconButton>
  );
}

export default DeleteButton;
